import React from 'react';
import { Button } from '../atoms';
import { UilAngleDown, UilAngleUp, UilPadlock } from '@iconscout/react-unicons';
import { useRouter } from 'next/router';

const item = [
  {
    id: 1,
    title: 'Tab 1',
    isVisible: false,
    content: 'Content 1',
  },
  {
    id: 2,
    title: 'Tab 2',
    isVisible: false,
    content: 'Content 2',
  },
  {
    id: 3,
    title: 'Tab 3',
    isVisible: false,
    content: 'Content 3',
  },
];

const TabVertical = (props) => {
  const { tabItem = item, theme = 'blue-hedgehog', variant = 'secondary', handleTab } = props;

  const router = useRouter();

  const [tab, setTab] = React.useState(tabItem);

  const onActive = (id) => {
    let _temp = [...tab];
    _temp.forEach((current) => {
      if (current.type === 'dropdown' && current.id === id) {
        current.isVisible = !current.isVisible;
      } else {
        if (current.id === id) {
          current.isVisible = true;
        } else {
          current.isVisible = false;
        }
      }
    });
    setTab(_temp);
    handleTab && handleTab(_temp);
  };

  React.useEffect(() => {
    setTab(tabItem);
  }, [tabItem]);

  return (
    <ul className="pb-28">
      {tabItem.map((item, i) => {
        return (
          <div key={i}>
            <li className="mb-2 mr-2">
              {item?.type === 'link' ? (
                <Button
                  className={`flex w-full hover:bg-gray-culture hover:rounded-lg`}
                  content={item?.contentType}
                  icon={item?.icon}
                  type="link"
                  link={item.isGranted === false ? item.blocked : item.link}
                  variant={item?.link === router?.pathname ? variant : 'transparent'}
                  theme={item?.link === router?.pathname ? theme : 'gray-davys'}
                >
                  {item.type !== 'dropdown' ? (
                    <span className="mr-10">{item.title}</span>
                  ) : (
                    <div className="flex w-full justify-between">
                      <span className="mr-10">{item.title}</span>
                      {item.isVisible ? <UilAngleUp /> : <UilAngleDown />}
                    </div>
                  )}
                </Button>
              ) : (
                <React.Fragment>
                  <Button
                    className={`flex w-full hover:bg-gray-culture hover:rounded-lg`}
                    content={item?.contentType}
                    icon={item?.icon}
                    action={() => onActive(item.id)}
                    variant={item?.isVisible && item?.type !== 'dropdown' ? 'secondary' : 'transparent'}
                    theme={item?.isVisible && item?.type !== 'dropdown' ? theme : 'gray-davys'}
                  >
                    {item.type !== 'dropdown' ? (
                      <span className="mr-10">{item.title}</span>
                    ) : (
                      <div className="flex items-center w-full justify-between">
                        <span className="mr-10">{item.title}</span>
                        {item.isVisible ? <UilAngleUp /> : <UilAngleDown />}
                      </div>
                    )}
                  </Button>
                  <ul className="transition-all duration-700 ease-in-out overflow-y-scroll scroll-hide mt-1">
                    {item?.type === 'dropdown' &&
                      item.isVisible &&
                      item?.subTab?.map((sub, i) => {
                        return (
                          <li className={`mb-2 mt-1`} style={{ paddingLeft: '2rem' }} key={i}>
                            <Button
                              className={`flex w-full hover:bg-gray-culture hover:rounded-lg`}
                              content={sub?.contentType}
                              icon={sub?.icon}
                              type="link"
                              link={sub.isGranted === false ? sub.blocked : sub.link}
                              variant={sub?.link === router?.pathname ? 'secondary' : 'transparent'}
                              theme={sub?.link === router?.pathname ? theme : 'gray-davys'}
                            >
                              <div className="flex items-center w-full justify-between">
                                <span className="mr-10"> {sub.title}</span>
                              </div>
                            </Button>
                          </li>
                        );
                      })}
                  </ul>
                </React.Fragment>
              )}
            </li>
          </div>
        );
      })}
    </ul>
  );
};

export default TabVertical;
